import { render, staticRenderFns } from "./ConfigurationHead.vue?vue&type=template&id=740a9286"
import script from "./ConfigurationHead.vue?vue&type=script&lang=js"
export * from "./ConfigurationHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports